module.exports = __webpack_public_path__ + "img/filter_list.e7604e7f.svg";